module.exports = __webpack_public_path__ + "static/blocks-a7149b1fc28ad1ecb1140e7fedc31218.png";